export default __webpack_public_path__ + "static/media/everycred-logo.a270ee12.svg";